import { render, staticRenderFns } from "./user-balance.vue?vue&type=template&id=c73083d4&scoped=true&"
import script from "./user-balance.vue?vue&type=script&lang=js&"
export * from "./user-balance.vue?vue&type=script&lang=js&"
import style0 from "./user-balance.vue?vue&type=style&index=0&id=c73083d4&prod&lang=scss&"
import style1 from "./user-balance.vue?vue&type=style&index=1&id=c73083d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73083d4",
  null
  
)

export default component.exports